<div *ngIf="init">
  <textarea-input
    [title]="'Materiaal'"
    [minHeight]="200"
    [initContent]="adjustment.material"
    (answer)="setAdjustmentMaterial($event)"
  ></textarea-input>

  <textarea-input
    [title]="'Aantal'"
    [minHeight]="200"
    [initContent]="adjustment.amountDesign"
    (answer)="amountDesignChange($event)"
  ></textarea-input>

  <textarea-input
    [title]="'Afmetingen'"
    [minHeight]="200"
    [initContent]="adjustment.size"
    (answer)="setAdjustmentSize($event)"
  ></textarea-input>

  <textarea-input
    [title]="'Extra info ontwerp'"
    [minHeight]="200"
    [initContent]="adjustment.extraInfoDesign"
    [sensitive]="true"
    (answer)="extraInfoDesignChanged($event)"
  ></textarea-input>

  <textarea-input
    [title]="'Info installateur'"
    [minHeight]="200"
    [initContent]="
      adjustment.withPlacementNotes == null
        ? baseProjectPlacementInfo
        : adjustment.withPlacementNotes
    "
    [sensitive]="true"
    (answer)="withPlacementNotesChanged($event)"
  ></textarea-input>
</div>
